export default class Filters {
  static getVendor() {
    return 'nematis'
  }

  static getEnvironment() {
    return null
  }

  static getFilterType() {
    return null
  }

  static getFilterTypeName() {
    return null
  }

  static getFilterNameSeparator() {
    return '.'
  }

  static getNamespaceSeparator() {
    return '/'
  }

  static filterName(name) {
    const filterNameSeparator = this.getFilterNameSeparator()
    const namespaceRegex = new RegExp(this.getNamespaceSeparator(), 'g')
    name = name.replace(namespaceRegex, filterNameSeparator)

    const parts = this._noEmptyArrayValues([this.getFilterTypeName(), name.trim()])

    return parts.join(filterNameSeparator)
  }

  static namespace(name) {
    const namespaceSeparator = this.getNamespaceSeparator()
    const filterNameRegex = new RegExp(`\\${this.getFilterNameSeparator()}`, 'g')
    name = name.replace(filterNameRegex, namespaceSeparator)

    const parts = this._noEmptyArrayValues([
      this.getVendor(),
      this.getEnvironment(),
      this.getFilterType(),
      this.getFilterTypeName(),
      name.trim()
    ])

    return parts.join(namespaceSeparator)
  }

  static getHooksInstanceName() {
    return `_${this.getVendor()}Hooks`
  }

  /* WRAPPERS FOR WP HOOKS API METHODS */

  // eslint-disable-next-line no-magic-numbers
  static addAction(hookName, callback, callbackUniqueId, priority = 10) {
    const namespace = this._buildNamespaceArgument(hookName, callbackUniqueId)

    this._hooks.addAction(this.filterName(hookName), namespace, callback, priority)
  }

  // eslint-disable-next-line no-magic-numbers
  static addFilter(hookName, callback, callbackUniqueId, priority = 10) {
    const namespace = this._buildNamespaceArgument(hookName, callbackUniqueId)

    this._hooks.addFilter(this.filterName(hookName), namespace, callback, priority)
  }

  static removeAction(hookName, callbackUniqueId) {
    this._hooks.removeAction(this.filterName(hookName), this._buildNamespaceArgument(hookName, callbackUniqueId))
  }

  static removeFilter(hookName, callbackUniqueId) {
    this._hooks.removeFilter(this.filterName(hookName), this._buildNamespaceArgument(hookName, callbackUniqueId))
  }

  static removeAllActions(hookName) {
    this._hooks.removeAllActions(this.filterName(hookName))
  }

  static removeAllFilters(hookName) {
    this._hooks.removeAllFilters(this.filterName(hookName))
  }

  static doAction(hookName, ...args) {
    this._hooks.doAction(this.filterName(hookName), ...args)
  }

  static async doActionAsync(hookName, ...args) {
    await this._runAsyncHook('actions', false, hookName, ...args)
  }

  static applyFilters(hookName, ...args) {
    return this._hooks.applyFilters(this.filterName(hookName), ...args)
  }

  static applyFiltersAsync(hookName, ...args) {
    return this._runAsyncHook('filters', true, hookName, ...args)
  }

  static doingAction(hookName) {
    return this._hooks.doingAction(this.filterName(hookName))
  }

  static doingFilter(hookName) {
    return this._hooks.doingFilter(this.filterName(hookName))
  }

  static didAction(hookName) {
    return this._hooks.didAction(this.filterName(hookName))
  }

  static didFilter(hookName) {
    return this._hooks.didFilter(this.filterName(hookName))
  }

  static hasAction(hookName, callbackUniqueId) {
    const namespace = this._buildNamespaceArgument(hookName, callbackUniqueId)

    return this._hooks.hasAction(this.filterName(hookName), namespace)
  }

  static hasFilter(hookName, callbackUniqueId) {
    const namespace = this._buildNamespaceArgument(hookName, callbackUniqueId)

    return this._hooks.hasFilter(this.filterName(hookName), namespace)
  }

  /* INTERNAL HELPERS FOR WP HOOKS API PROPERTIES */

  static get _actions() {
    return this._hooks.actions
  }

  static get _filters() {
    return this._hooks.filters
  }

  static get _defaultHooks() {
    return this._hooks.defaultHooks
  }

  /* INTERNAL METHODS */

  static get _hooks() {
    // attempt to get global hooks instance
    // note: there MUST be only one instance per website
    const hooksInstanceName = this.getHooksInstanceName()
    if (!(hooksInstanceName in window)) {
      return null
    }

    return window[hooksInstanceName]
  }

  static _noEmptyArrayValues(parts) {
    return parts.filter((v) => v)
  }

  static _buildNamespaceArgument(hookName, callbackUniqueId) {
    const namespaceSeparator = this.getNamespaceSeparator()

    return this._noEmptyArrayValues([this.namespace(hookName, true), callbackUniqueId]).join(namespaceSeparator)
  }

  /* eslint-disable consistent-return */
  static async _runAsyncHook(storeKey, returnFirstArg, hookName, ...args) {
    const filterName = this.filterName(hookName)
    const hooksStore = this._hooks[storeKey]

    if (!hooksStore[filterName]) {
      hooksStore[filterName] = {
        handlers: [],
        runs: 0
      }
    }

    hooksStore[filterName].runs++

    const handlers = hooksStore[filterName].handlers
    if (!handlers || !handlers.length) {
      return returnFirstArg ? args[0] : null
    }

    const hookInfo = {
      name: filterName,
      currentIndex: 0
    }

    hooksStore.__current.push(hookInfo)
    while (hookInfo.currentIndex < handlers.length) {
      const handler = handlers[hookInfo.currentIndex]

      try {
        // eslint-disable-next-line no-await-in-loop
        const result = await handler.callback.apply(null, args)
        if (returnFirstArg) {
          args[0] = result
        }
      } catch (e) {
      }

      hookInfo.currentIndex++
    }

    hooksStore.__current.pop()

    if (returnFirstArg) {
      return args[0]
    }
  }
}
